import { Get } from 'config/apiServiceConfig'
import AxiosInstance from 'config/apiServiceApiGateway'

import { LocationType } from './loadingDock'

const getInboundScheduleEndpoint = '/api/sm/:version/inbound-schedule/'
const getDetailLocationEndpoint = '/api/location/:locationId'
const getCountScheduledEndpoint = '/commercial/internal/v1/purchase-order-statistics'

export type InboundScheduleActionType = 'CREATE' | 'UPDATE' | 'DELETE' | 'VIEW'

export type InboundScheduleTimeSlotType = {
  timeSlotId: number
  action: InboundScheduleActionType[]
  inboundScheduleData: {
    scheduleId: number
    vendor: {
      vendorId: number
      vendorName: string
    } | null
    totalPo: number
    totalPcs: number
    maxPcs: number
  } | null
  isSameAsAbove?: boolean
  date?: string
}

export type InboundScheduleType = {
  date: string
  timeSlotData: InboundScheduleTimeSlotType[]
}

export type GetInboundScheduleType = {
  data: InboundScheduleType[]
}

export type GetInboundScheduleParamsType = {
  startDate: string
  endDate: string
  locationId: number
  loadingDockId: number
}

export type GetCountScheduledType = {
  data: {
    unscheduledPo: number
    unscheduledVendor: number
    scheduledPo: number
    scheduledVendor: number
  }
}

type GetPurchaseOrderStatisticsType = {
  data: {
    total_unscheduled_po: number
    total_unscheduled_vendor: number
    total_scheduled_po: number
    total_scheduled_vendor: number
  }
  error: {
    status: boolean
    message: string
    code: number
  }
}

export type InboundScheduleAvailableSlotType = {
  id: number
  name: string
  start_at: string
  end_at: string
  timeslot_productivity: number
  slot_range_label: string
  remarks: string
  is_active: boolean
  location_id: number
  type: 'FCFS_PARENT' | 'FCFS_CHILD' | 'REGULAR'
}

export type InboundScheduleDataType = {
  date: string
  time_slot_info: {
    total_pcs: number
    max_pcs: number
  }
  time_slot_data: {
    time_slot_id: number
    time_slot_type: string
    action: string[]
    inbound_schedule_data: {
      id: number
      total_po: number
      total_pcs: number
      max_pcs: number
    } | null
  }[]
}

export const getInboundSchedule = (params: GetInboundScheduleParamsType) =>
  Get<GetInboundScheduleType>({ url: getInboundScheduleEndpoint, version: 'v1', params })

export const getLocationDetail = (locationId: string) =>
  Get<LocationType>({ url: getDetailLocationEndpoint, urlParams: { locationId } })

export const getCountScheduled = async () => {
  const response = await AxiosInstance.Get<GetPurchaseOrderStatisticsType, true>({
    url: getCountScheduledEndpoint,
  })
  const statistics = response.data.data

  return {
    ...response,
    data: {
      data: {
        unscheduledPo: statistics.total_unscheduled_po,
        unscheduledVendor: statistics.total_unscheduled_vendor,
        scheduledPo: statistics.total_scheduled_po,
        scheduledVendor: statistics.total_scheduled_vendor,
      },
    },
  }
}

export const deleteInboundSchedule = (scheduleId: number) =>
  AxiosInstance.Delete({
    url: '/commercial/internal/v1/inbound-schedules/:scheduleId',
    version: 'v1',
    urlParams: { scheduleId },
  })

export const getInboundScheduleApi = (params: GetInboundScheduleParamsType) =>
  AxiosInstance.Get<{ data: InboundScheduleDataType[] }, true>({
    url: '/commercial/internal/:version/inbound-schedules',
    version: 'v1',
    convertRequest: true,
    params,
  })

export const getAvailableSlotInboundScheduleApi = (loadingDockId: number) =>
  AxiosInstance.Get<{ data: InboundScheduleAvailableSlotType[] }, true>({
    url: '/commercial/internal/:version/loading-docks/:loadingDockId/time-slots?page=JADWAL_PO_SOURCING&is_active=true',
    version: 'v1',
    urlParams: { loadingDockId },
  })
